import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "section content-container" }
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "report-container island" }
const _hoisted_5 = { class: "report-container island" }

import { MessagingReportsData, messagingReportsApi } from '@/features/reports/services/messagingReportsApi';
import ContactTrendCharts from '@/features/reports/components/conversations/ContactTrendCharts.vue';
import ConversationTrendCharts from '@/features/reports/components/conversations/ConversationTrendCharts.vue';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MessagingReports',
  setup(__props) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const selectedDateOption = computed(() => store.getters.selectedDateOption);

const setLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const data = ref<MessagingReportsData>({});

const loadingError = ref(false);
const loadedData = ref(false);

watch(
  selectedDateOption,
  async (filter, previous) => {
    if (filter && filter === previous) {
      return;
    }

    await loadData();
  },
  { immediate: true },
);

async function loadData() {
  loadedData.value = false;
  loadingError.value = false;
  setLoading(true);
  try {
    data.value = await messagingReportsApi.loadReportData(currentWorkspace.value.id, {
      startDate: selectedDateOption.value.getDateRange().start,
      endDate: selectedDateOption.value.getDateRange().end,
      grouping: selectedDateOption.value.group,
    });
    loadedData.value = true;
  } catch {
    loadingError.value = true;
  } finally {
    setLoading(false);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ContactTrendCharts, {
            data: data.value.newContactsTrendReport,
            loadedData: loadedData.value,
            loadingError: loadingError.value
          }, null, 8, ["data", "loadedData", "loadingError"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ConversationTrendCharts, {
            data: data.value.newConversationsTrendReport,
            loadedData: loadedData.value,
            loadingError: loadingError.value
          }, null, 8, ["data", "loadedData", "loadingError"])
        ])
      ])
    ])
  ]))
}
}

})